import {type RouteConfigPath} from './route-config-path';

// Convenience function to easily assign paths
export const withPath = <T extends RouteConfigPath>(path: T) => path;
